import React from "react";
import { TimePicker } from "antd";
const format = "HH:mm";
const TimeDeparture = ({ index, values, handleChange }) => {
  return (
    <>
      <input
        placeholder="hh:mm"
        type="time"
        className="form-control" // name="arrivalTime"
        id={`flightLegs.onward[${index}].departureTime`}
        name={`flightLegs.onward[${index}].departureTime`}
        // display="Request Date"
        // onBlur={handleBlur}
        value={values?.flightLegs?.onward[index]?.departureTime || ""}
        onChange={handleChange}
        // touched={touched?.flightLegs?.onward[index]?.departureTime}
        // error={errors?.flightLegs?.onward[index]?.departureTime}
      />
    </>
  );
};

export default TimeDeparture;
